
import {createSlice} from "@reduxjs/toolkit";

export const viewershipSearchSlice = createSlice({
    name: 'viewershipSearchSlc',
    initialState: {value: {
            productId: null,
            productName: null,
            episodeName: null,
            photoStartDateFrom: null,
            photoStartDateTo: null,
            seriesExternalId: null,
            seriesName: null,
            seasonExternalId: null,
            seasonNumberFrom: null,
            seasonNumberTo: null,
            seasonName: null,
            platformId: null,
            platformName: null,
            platformService: null,
            usageMarket: null,
            territory: null,
            viewDateFrom: null,
            viewDateTo: null,
            viewsFrom: null,
            viewsTo: null,
            viewedMinutesFrom: null,
            viewedMinutesTo: null,
            ratingFrom: null,
            ratingTo: null,
            id: null,
            externalId: null,
            source: null,
            status: null,
            participations: null,
            residuals: null,
            royalties: null
        }},
    reducers:

{
        changeViewershipSearch: (state, action) => {
                state.value = {
                        ...state.value,  // Keep existing fields
                        ...action.payload // Merge new values
                };
        }
}
});

export const { changeViewershipSearch } = viewershipSearchSlice.actions;

export default  viewershipSearchSlice.reducer ;

